import { Pipe, PipeTransform } from '@angular/core';
import { DeviceDataPoint, FormatDataPointOptions } from '../interfaces/data-points';
import { formatDataPoint } from '../utils/data-point-utils';

@Pipe({
    name: 'formatDataPoint',
    standalone: true
})
export class FormatDataPointPipe implements PipeTransform {

  transform(value: any, options?: FormatDataPointOptions, ...args: unknown[]): string {
    return options ? formatDataPoint(value, options) : formatDataPoint(value);
  }

}
